import { Component, OnInit, Input } from '@angular/core';
import { MapsAddStuffService } from '../../maps-add-stuff.service';
import { MapsAddStuffOptions } from '../../maps-add-stuff-options.interface';

@Component({
  selector: 'app-add-stuff',
  templateUrl: './add-stuff.component.html',
  styleUrls: ['./add-stuff.component.less']
})
export class AddStuffComponent implements OnInit {

  constructor(public mapsAddStuffService: MapsAddStuffService) { }

  @Input() showAddStuff: boolean = false;

  @Input() set options(opt: MapsAddStuffOptions) {
    this.attachChanges(opt)
  }

  addPropertyFromContextualSubscription: any;
  addRetailerFromContextualSubscription: any;
  addMarkerFromContextualSubscription: any;
  
  // Attach all the changes received in the options object
  attachChanges(options): void {
    Object.keys(options).forEach(a => {
      if (this.mapsAddStuffService.hasOwnProperty(a)) this.mapsAddStuffService[a] = options[a]
    });
  }

  ngOnInit() {}

  ngAfterViewInit() {
    let w = (<any>window);
    this.addPropertyFromContextualSubscription = w.Events.subscribe('addPropertyFromContextual',()=>{
      w.Events.publish('getLoggedInCheck', (call)=>{
        if(call) {
          this.beginAddPropertyFlow();
        } else {
          w.Events.publish('updatePopupRoute','sign-up');
        }
      });
    });
    this.addRetailerFromContextualSubscription = w.Events.subscribe('addRetailerFromContextual',()=>{
      w.Events.publish('getLoggedInCheck', (call)=>{
        if(call) {
          this.beginAddRetailerFlow();
        } else {
          w.Events.publish('updatePopupRoute','sign-up');
        }
      });
    });
    this.addMarkerFromContextualSubscription = w.Events.subscribe('addMarkerFromContextual',()=>{
      w.Events.publish('getLoggedInCheck', (call)=>{
        if(call) {
          this.addPin();
        } else {
          w.Events.publish('updatePopupRoute','sign-up');
        }
      });
    });  
  }

  isApplicationTourbooks() {
    return (<any>window).isApplicationTourbooks();
  }

  beginAddRetailerFlow() {
    this.mapsAddStuffService.addRetailerFlowActiveSource.next(true);
    this.closePopup();
  }

  beginAddPropertyFlow() {
    this.mapsAddStuffService.addPropertyFlowActiveSource.next(true);
    this.closePopup();
  }

  closePopup() {
    let w = (<any>window);
    w.Events.publish('closeAddStuffDropdown');
  }

  addPin() {
    if(this.isApplicationTourbooks()) {
      this.mapsAddStuffService.addPinFlowActiveSource.next(true);
      this.closePopup();
    }
  }

  removeSubscriptions() {
    this.addPropertyFromContextualSubscription && this.addPropertyFromContextualSubscription.unsubscribe();
    this.addRetailerFromContextualSubscription && this.addRetailerFromContextualSubscription.unsubscribe();
    this.addMarkerFromContextualSubscription && this.addMarkerFromContextualSubscription.unsubscribe();
  }

  ngOnDestroy() {
    this.removeSubscriptions();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/components/add-stuff/add-stuff.component.ts